module.exports = __webpack_public_path__ + "img/health_bg.b55daa77.png";